module.exports = __webpack_public_path__ + "img/calendarline.b78b0d68.svg";